module.exports = __webpack_public_path__ + "static/media/logo.5bd5373c.svg";